import { useSelector } from "react-redux";
import { RootState } from "State/store";

export const useCustomerState = () =>
  useSelector((state: RootState) => state.customer);
